export const floatToPercent = (number: number | null | undefined): number | null => {
  if (!number) return null
  return Math.round(number * 100)
}
